type AmountUnit = 'thousand' | 'million' | 'billion';

export const extractAndFormatDollar = (input: string): string => {
  if (!input) return '';

  const regex = /(\$?[\d.,]+)\s*(thousand|million|billion)?/gi;
  const matches = input.match(regex);

  if (!matches) {
    return '';
  }

  let totalAmount = 0;
  const [, amountStr, unit] = matches[0].match(/(\$?[\d.,]+)\s*(thousand|million|billion)?/i) as [string, string, AmountUnit];
  const amount = parseFloat(amountStr.replace(/[\$?,]/g, ''));

  if (!unit || unit.toLowerCase() === 'thousand') {
    totalAmount += amount;
  } else if (unit.toLowerCase() === 'million') {
    totalAmount += amount * 1000000;
  } else if (unit.toLowerCase() === 'billion') {
    totalAmount += amount * 1000000000;
  }

  if (totalAmount) {
    return totalAmount.toFixed(0);
  }
  return '';
};
